// extracted by mini-css-extract-plugin
export default {"wrap":"BgZJmNEnh5mWKWB9MJpX"};